export default class TurnstileService {
    private token: string | null = null;
    private tokenPromise: Promise<string>;
    private resolveToken: ((value: string | null) => void) | null = null;

    constructor(sitekey: string) {
        this.tokenPromise = new Promise((resolve, reject) => {
            this.resolveToken = resolve;

            turnstile.ready(() => {
                turnstile.render('#my-turnstile', {
                    sitekey,
                    callback: token => {
                        this.token = token;
                        this.resolveToken?.(token);
                        this.resolveToken = null;
                    },
                    'error-callback': error => {
                        console.error(error);
                        reject(error);
                    },
                });
            });
        });
    }

    public async awaitToken(): Promise<string> {
        return this.token ?? await this.tokenPromise;
    }

    public skipValidation(): void {
        if (!this.token) {
            this.resolveToken?.(null);
            this.resolveToken = null;
        }
    }
}
